module.exports = __webpack_public_path__ + "static/media/user.09565097.svg";